import { Injectable } from "@angular/core";
import { ReceivedLabSample } from "../../model/received-lab-sample";
import { DataService } from "../data.service";
import { stringify } from "querystring";

@Injectable({
  providedIn: "root",
})
export class ReceivedLabSampleService {
  constructor(private dataService: DataService) {}

  private readonly endPoint: string = "/receivedlabsample";

  async getIsEnabled(medicalAppointmentId: number): Promise<boolean> {
    const params = { medicalAppointmentId };
    return await this.dataService
      .get<boolean>(`${this.endPoint}/getisenabled`, params)
      .toPromise();
  }

  async get(
    medicalAppointmentId: number,
    noDefault: boolean = false
  ): Promise<ReceivedLabSample[]> {
    const params = { medicalAppointmentId, noDefault };
    return await this.dataService
      .get<ReceivedLabSample[]>(`${this.endPoint}/getreceivedlabsample`, params)
      .toPromise();
  }

  async getByMedicalAppointmentProcedureIds(
    medicalAppointmentProcedureIds: number[],
    noDefault: boolean = false
  ): Promise<ReceivedLabSample[]> {
    const params = {
      medicalAppointmentProcedureIds: JSON.stringify(medicalAppointmentProcedureIds),
      noDefault,
    };
    return await this.dataService
      .get<ReceivedLabSample[]>(
        `${this.endPoint}/getByMedicalAppointmentProcedureIds`,
        params
      )
      .toPromise();
  }

  async update(items: ReceivedLabSample[]): Promise<boolean> {
    const params = { items };
    return await this.dataService
      .post<boolean>(`${this.endPoint}/update`, params)
      .toPromise();
  }
}
